export const DefaultIPv4: { [key: string]: string } = {
    PLACEHOLDER: "192.0.2.1", // RFC5737
    SUBNET: "24",
    CALCULATE: "Calculate",
    VALIDATION_ERROR: "Invalid IPv4 address",
};

export const PRIVATE_CLASS_A_FIRST_OCTET = 10;

export const PRIVATE_CLASS_B_FIRST_OCTET = 172;

export const PRIVATE_CLASS_B_SECOND_OCTET_START = 16;

export const PRIVATE_CLASS_B_SECOND_OCTET_END = 31;

export const PRIVATE_CLASS_C_FIRST_OCTET = 192;

export const PRIVATE_CLASS_C_SECOND_OCTET = 168;

export const CLASS_A_FIRST_OCTET_START = 0;

export const CLASS_A_FIRST_OCTET_END = 127;

export const CLASS_B_FIRST_OCTET_START = 128;

export const CLASS_B_FIRST_OCTET_END = 191;

export const CLASS_C_FIRST_OCTET_START = 192;

export const CLASS_C_FIRST_OCTET_END = 223;

export const CLASS_D_FIRST_OCTET_START = 224;

export const CLASS_D_FIRST_OCTET_END = 239;
